import { ncFileStatuses } from '@helpers';
import { OPTabRequirementsContext } from '@components/operatorPanel/interfaces';

interface BuildOPTabRequirementsContextParams {
  isWithERP: boolean | null;
  isMachinePerspective: boolean;
  ncFileStatus: string | null | undefined;
}

export const buildOPTabRequirementsContext = ({
  isWithERP,
  isMachinePerspective,
  ncFileStatus,
}: BuildOPTabRequirementsContextParams): OPTabRequirementsContext => ({
  isMachinePerspective,
  erp: isWithERP === true,
  notUnknownNcFile: ncFileStatus !== ncFileStatuses.Unknown,
});
